import React from 'react';
import {
  CustomHeader,
  CompletedStatus,
  InProgressStatus,
  FailedStatus,
  InQueueStatus,
  CentralContainer
} from './styled';
import { convertISOToDateFormat } from '../../../../../util/timezone';
import { toLower } from 'lodash';
import ActivityLogRiskIndiModel from '../activityLogRiskIndiModel';
import AlertLevels from '../../../../common/components/AlertLevels';

const preventionAlertColors = (key, trmActions) => {
  return trmActions?.data?.find(
    ({ displayName }) => toLower(displayName) === toLower(key)
  )?.alertLevelColor;
};

export const columns = (trmActions, preventionResourceAccess) => {
  const result = [
    {
      title: <CustomHeader>Execution ID</CustomHeader>,
      key: 'id',
      render: (record) => {
        const { id } = record;
        return <b>{id}</b>;
      }
    },
    {
      title: <CustomHeader>Execution Date</CustomHeader>,
      key: 'id',
      render: (record) => {
        const { createdAt } = record;
        return <div>{convertISOToDateFormat(createdAt)}</div>;
      }
    },
    {
      title: <CustomHeader>Date Range</CustomHeader>,
      key: 'id',
      render: (record) => {
        const { executionConfiguration } = record;
        const executionConfigurationParsed = JSON.parse(executionConfiguration);
        const { training, prediction } = executionConfigurationParsed;
        const { dateRange: trainingDateRange } = training || {};
        const { dateRange: predictionDateRange } = prediction || {};
        return (
          <>
            <div>{`Training - ${convertISOToDateFormat(
              trainingDateRange?.from
            )} - ${convertISOToDateFormat(trainingDateRange?.to)}`}</div>
            <div>{`Prediction - ${convertISOToDateFormat(
              predictionDateRange?.from
            )} - ${convertISOToDateFormat(predictionDateRange?.to)}`}</div>
          </>
        );
      }
    },
    {
      title: <CustomHeader>Status</CustomHeader>,
      key: 'id',
      render: (record) => {
        const { status } = record;
        const lowerStatus = toLower(status);
        return (
          <>
            {lowerStatus === 'inprogress' && (
              <InProgressStatus>{status}</InProgressStatus>
            )}
            {lowerStatus === 'completed' && (
              <CompletedStatus>{status}</CompletedStatus>
            )}
            {lowerStatus === 'failed' && <FailedStatus>{status}</FailedStatus>}
            {lowerStatus === 'inqueue' && (
              <InQueueStatus>{status}</InQueueStatus>
            )}
          </>
        );
      }
    },
    {
      title: <CustomHeader>Alerts Count</CustomHeader>,
      dataIndex: 'totalAlert',
      key: 'totalAlert'
    },
    {
      title: <CustomHeader>Alerts Level</CustomHeader>,
      key: 'id',
      render: (record) => {
        if (!preventionResourceAccess) {
          const data = {
            High: record?.highAlert || 0,
            Good: record?.goodAlert || 0,
            Low: record?.lowAlert || 0
          };

          return <AlertLevels data={data} showColumnwise />;
        } else {
          const keys = Object.keys(record.levelsCount);
          return (
            <>
              {keys.map((key, index) => (
                <div
                  key={key}
                  style={{
                    color: preventionAlertColors(key, trmActions)
                  }}>
                  {key}: {record.levelsCount[key]}
                </div>
              ))}
            </>
          );
        }
      }
    }
  ];

  if (!preventionResourceAccess) {
    result.push({
      title: <CustomHeader>Risk Indicators</CustomHeader>,
      key: 'riskIndicators',
      render: ({ userThresholds = [], status = '' }) => {
        if (!preventionResourceAccess) {
          return (
            <CentralContainer>
              <ActivityLogRiskIndiModel
                userThresholds={userThresholds}
                disabled={status !== 'Completed'}
              />
            </CentralContainer>
          );
        }
      }
    });
  }

  return result;
};

export default columns;
